import { UserPref } from 'src/app/model/user-pref.model';

export class Account {
  userId!: string;
  userFirstName!: string;
  userLastName!: string;
  userFirstLastName!: string;
  userLastFirstName!: string;
  orgName!: string;
  userRoles!: string[];
  perms!: string[];
  orgId!:number;
  orgRoles!:string[];
  orgCity?: string;
  orgRegnName?: string;
  orgCountry?: string;
  offcPhonCntryCd?: number;
  offcPhonNum?: number;
  moblPhonCntryCd?: number;
  moblPhonNum?: number;
  lastLoginTmstmp?: string;
  subjCnt?: number;
  currentSubjectName?: string;
  currentSubjLastAccesed?: string;
  childOrgIds?: number[];
  userPrefs?: {[key: string]: string};
}
